import { render, staticRenderFns } from "./Layout_AuthSidebar.vue?vue&type=template&id=b855e1d6&"
import script from "./Layout_AuthSidebar.vue?vue&type=script&lang=js&"
export * from "./Layout_AuthSidebar.vue?vue&type=script&lang=js&"
import style0 from "./Layout_AuthSidebar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports